import ml from 'devegram-ml'
import translations from '@/multi-language/devegram-ml'
import langsConfig from '@/multi-language/languages-config'
import store from '@/store/index.js'
import router from '../../router'

export const bindWLogger = (globalData) => {
    window.W_LOGGER_DEBUG = true;
    window.W_LOGGER = function (...params) {
        if (W_LOGGER_DEBUG) console.log(...params)
    }
}

export const bindStoreAndRouter = (globalData) => {
    window.$router = router
    window.$store = store
    globalData['$store'] = store
    // globalData['$router'] = router
    return {
        store,
        router
    }
}

export const bindXModules = (globalData) => {
    let xmdoule = {
        basePath: 'modules/',
        modules: {},
        loadNameSpaced: async function (moduleNamespace, moduleName) {
            return new Promise(async (resolve, reject) => {
                let modulePath = this.basePath + moduleNamespace + '/' + moduleName
                let {module} = await import('@/' + modulePath + '/index.js')
                /*
                  !!! THIS WAS A TESTING FOR THE POSSIBILITY OF CONFIGURING FRONTEND MODULE FROM THE BACKEND !!!

                  module.caption = 'HELLO IT Is ME'
                  console.log('loading Module', module.caption)
                */
                this.modules[moduleName] = module

                if (!module.hasOwnProperty('noRoutes')) {
                    let {default: moduleRoutes} = await import('@/' + modulePath + '/routes.js')

                    let {routes} = router.options
                    let routeData = routes.find(r => r.path === module.mainRoute)
                    routeData.children = moduleRoutes
                    router.addRoute(routeData)
                }

                this.loadModuleStore(module).then(() => {
                    resolve()
                })
            })
        },
        load: async function (moduleName) {
            return new Promise(async (resolve, reject) => {
                let {module} = await import('@/' + this.basePath + moduleName + '/index.js')
                /*module.caption = 'HELLO IT Is ME'
                console.log('loading Module', module.caption)*/
                this.modules[moduleName] = module

                if (!module.hasOwnProperty('noRoutes')) {
                    let {default: moduleRoutes} = await import('@/' + this.basePath + moduleName + '/routes.js')

                    let {routes} = router.options
                    let routeData = routes.find(r => r.path === module.mainRoute)
                    routeData.children = moduleRoutes
                    router.addRoute(routeData)
                }

                this.loadModuleStore(module).then(() => {
                    resolve()
                })
            })
        },
        loadModuleStore: function (module) {
            return new Promise(async (resolve, reject) => {
                let moduleName = module.info.name
                let vuexModules = module.vuexModules
                let moduleNameToRegister = null
                if (vuexModules.length === 0) resolve()
                for (let i = 0; i < vuexModules.length; i++) {
                    let vuexModule = vuexModules[i]
                    moduleNameToRegister = moduleName + '-' + vuexModule//this.kebabToCamelCase(moduleName + '-' + vuexModule)
                    if (!$store.hasModule(moduleNameToRegister)) {
                        let {default: importedModule} = await import('@/' + this.basePath + moduleName + '/store/' + vuexModule + '.js')
                        $store.registerModule(moduleNameToRegister, importedModule)
                        resolve()
                    } else {
                        resolve()
                    }
                }
            })
        },
        vuexAction: function (params) {
            return new Promise((resolve, reject) => {
                $store.dispatch(params.moduleName + '-' + params.vuexModule + '/' + params.action, params.data || {}).then(r => {
                    resolve(r)
                }).catch(e => {
                    reject(e)
                })
            })
        },
        /*unloadVuexModule: (moduleName) => {
          let camelCase = this.kebabToCamelCase(moduleName)
          $store.unregisterModule(camelCase + 'API')
          $store.unregisterModule(camelCase + 'State')
        },*/
        kebabToCamelCase: (str) => {
            return str.split('-').map((item, index) => index ? item.charAt(0).toUpperCase() + item.slice(1).toLowerCase() : item).join('')
        }
    }

    window.$xmodule = xmdoule
    globalData['$xmodule'] = xmdoule
}

export const bootUILangSetting = (globalData) => {
    let ul = localStorage.getItem('ui_lang')
    if (!ul) {
        localStorage.setItem('ui_lang', 'en')
        ul = 'en'
    }

    ml.addLang(translations)
    ml.setLang('en')
    globalData['$langConfig'] = {
        lang: ul,
        dir: langsConfig.languages[ul].dir,
        align: langsConfig.languages[ul].align,
        cssClass: 'text-' + langsConfig.languages[ul].align
    }

    globalData['$ml'] = ml

}

export const bindGlobalData = (Vue, globalData) => {
    let gp = Vue.prototype
    for (let e in globalData) {
        gp[e] = globalData[e]
    }
}

export default {
    bindStoreAndRouter,
    bootUILangSetting,
    bindGlobalData,
    bindXModules,
    bindWLogger
}
